import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
} from "@heroui/react";
import { FaTriangleExclamation } from "react-icons/fa6";

export function ConfirmResolveModal({
  isOpen,
  onOpenChange,
  message,
  onConfirm,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  message: string;
  onConfirm: () => void;
}) {
  return (
    <Modal
      classNames={{
        backdrop: "z-[500]",
        wrapper: "z-[500]",
      }}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      backdrop="blur"
      scrollBehavior="outside">
      <ModalContent>
        {(onClose) => (
          <>
            <ModalBody className="py-6">
              <div className="flex flex-row gap-4 items-center mb-2">
                <div className="bg-warning-100 p-4 max-w-fit rounded-xl">
                  <FaTriangleExclamation className="text-warning" />
                </div>
                <span className="text-xl font-bold">Внимание!</span>
              </div>
              <span>{message}</span>
              <span>Действие невозможно отменить. Продолжить?</span>
            </ModalBody>
            <ModalFooter>
              <div className="flex flex-row gap-4 justify-end items-center w-full">
                <Button variant="flat" color="default" onPress={onClose}>
                  Нет, я передумал
                </Button>
                <Button
                  variant="flat"
                  color="warning"
                  onPress={() => {
                    onConfirm();
                    onClose();
                  }}>
                  Да, я уверен
                </Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
